import React from "react";
import RadioButtonDefecto from "../../../../Common/Components/RadioButtonDefecto2";

const IngresoSolicitud = ({ data, selectRadio }) => {
    const { GET_INGRESO_SOLICITUDES } = data;
    //[SP_Get_Solicitud_Estado]
    return (
        <div className="row top-separator-xs">
            <div className="col-xs-12">
                <label className="label-primary">{"Ingreso de Solicitudes - Estado"}</label>

                {GET_INGRESO_SOLICITUDES.map(item => {
                    const referencia = `GIS-${item.Id}`;

                    return (
                        <RadioButtonDefecto
                            key={item.Id}
                            nombre={"GIS"}
                            descripcion={item.Descripcion}
                            valor={item.Id}
                            checked={item.Checked}
                            referencia={referencia}
                            selectRadio={(valor) => selectRadio("GET_INGRESO_SOLICITUDES", valor)} />
                    );
                })}

                {data.ERROR_PRODUCT["seleccionoIngresoSolicitudes"] == false
                    && <label className="error">{"Debe seleccionar al menos un estado."}</label>}
            </div>
        </div>
    );
}

export default IngresoSolicitud;